export const generateKey = () => ((Math.random() * 0xffffff) << 0).toString(16);
